import React, { useState } from 'react';

import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import Drawer from '@material-ui/core/Drawer';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ResponsiveModal({ open, onClose, children, fullScreen, className, drawerProps = {}, dialogProps = {} }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!open) return null;

  return isMobile ? (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      {...drawerProps}
      className={className}
      classes={{ paperAnchorBottom: 'overflow-hidden'}}
    >
    {children}
    </Drawer>
  ) : (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen || isMobile}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      className={className}
      {...dialogProps}
    >
    {children}
    </Dialog>
  );
}